import React from 'react'
import { Drawer } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
// eslint-disable-next-line import/no-cycle
import DetailComplaint from '../../complaints/DetailComplaint'
import { IComputedMatch } from '../../../types/interfaces'

interface ComplaintDetailDrawerProps {
	complaintId: number | null
	open: boolean
	onClose: () => void
}

const ComplaintDetailDrawer: React.FC<ComplaintDetailDrawerProps> = ({ complaintId, open, onClose }) => {
	const { t } = useTranslation('pages')

	// vytvárame computedMatch objekt ako ho DetailComplaint očakáva
	const computedMatch: IComputedMatch<{ id: number }> = {
		isExact: true,
		params: {
			id: complaintId ?? -1
		},
		path: '/fake-path/:id',
		url: `/fake-path/${complaintId}`
	}

	return (
		<Drawer
			title={
				<div className="flex items-center space-x-4">
					<CloseOutlined onClick={onClose} style={{ color: '#aaa' }} />
					<span>
						{t('pages:Detail sťažnosti')} {complaintId !== null && `(ID: ${complaintId})`}
					</span>
				</div>
			}
			width={1000}
			visible={open}
			onClose={onClose}
			closeIcon={<></>}
		>
			{complaintId !== null && (
				<DetailComplaint computedMatch={computedMatch} />
			)}
		</Drawer>
	)
}

export default ComplaintDetailDrawer
